import './styles/LoadingSpinner.css'

export interface LoadingSpinnerProps {
  contextName?: string
  prefix?: string
  show: boolean
}

const LoadingSpinner = ({ contextName, prefix = 'Loading', show }: LoadingSpinnerProps) => {
  const loadingText = `${prefix} ${contextName}`

  if (show) {
    return (
      <div className="absolute-center" style={{ width: '100%', height: '100%' }}>
        <div className="la-line-spin-fade-rotating p-2">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        {contextName && <div>{loadingText}</div>}
      </div>
    )
  }
  return null
}

export default LoadingSpinner
